const STORAGE_KEY = {
  STORE_NAME: "storeName",
  USER: "@user",
};

const SESSION_EST_RESULT_KEYS = {
  MST_PROC_FEE: "mst-proc-fee",
  SELECTED_CAR_INFO: "selectedCarInfo",
  NEW_QUOTE_MAKER: "new-quote-maker",
  NEW_QUOTE_TIRE: "new-quote-tire",
  SELECTED_PAGE: "selected-page",
  QUOTE_BY: "quote-by",
  SELECTED_MAKER: "selected-maker",
  NEW_QUOTE_FROM: "new-quote-from",
  SELECTED_TIRE: "selectedTire",
  TIRE_TYPE: "tire-type",
} as const;

const SESSION_KEY = {
  // Quote related keys
  NEW_QUOTE_FROM: "new-quote-from",
  NEW_QUOTE_MAKER: "new-quote-maker",
  NEW_QUOTE_TIRE: "new-quote-tire",
  NEW_QUOTE_WHEEL: "new-quote-wheel",
  QUOTE_BY: "quote-by",
  SELECTED_PAGE: "selected-page",
  TIRE_TYPE: "tire-type",

  // Selected items keys
  SELECTED_CAR_INFO: "selectedCarInfo",
  SELECTED_TIRE: "selected-tire",
  SELECTED_WHEEL: "selected-wheel",
  SELECTED_MAKER: "selected-maker",
  SELECTED_CATEGORY: "selected-category",

  // Proc fee related keys
  MST_PROC_FEE: "mst-proc-fee",
  MST_PROC_WHEEL_FEE: "mst-proc-wheel-fee",

  // Set tire related keys
  SET_TIRE_RECOMMEND_FLAG: "set-tire-recommend-flag",
  SET_TIRE_CURRENT_PAGE: "set-tire-current-page",
  SET_TIRE_SELECTED_MAKER: "set-tire-selected-maker",
  SET_TIRE_SELECTED_CATEGORY: "set-tire-selected-category",

  // Wheel related keys
  WHEEL_SELECTED_MAKER: "wheel-selected-maker",
  WHEEL_SELECTED_CATEGORY: "wheel-selected-category",
  WHEEL_STORE_STATE: "wheel-store-state",

  // Pagination and filtering keys
  CURRENT_PAGE: "current-page",
  RECOMMEND_FLAG: "recommend-flag",

  // Navigation keys
  TIRE_WHEEL_TIRE_FROM: "tire-wheel-tire-from",
} as const;

export { STORAGE_KEY, SESSION_EST_RESULT_KEYS, SESSION_KEY };
